<template>
  <div class="pad-module-layout">
    <div class="pad-module-header fx-pad-header" v-if="!$route.meta.hideHead">
      <padHeader :IsHome="ishome" :Title="title" />
    </div>
    <div class="pad-module-content">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>
<script>
import padHeader from "./header";
export default {
  components: { padHeader },
  data() {
    return {
      ishome: false
    };
  },
  props: {
    title: String
  }
};
</script>
<style lang="scss" >
@import "./pad.scss";
</style>
<style lang="scss" scoped>
.pad-module-layout {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  height: 100vh;
  .pad-module-header {
    height: 50px;
    flex-shrink: 0;
    // background: #2d8cf0;
    color: #fff;
  }
  .pad-module-content {
    overflow: auto;
    flex: 1;
  }
}
</style>